module.exports = __webpack_public_path__ + "static/img/8.d937b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/8.png
// module id = RnsM
// module chunks = 0